export default __webpack_public_path__ + "static/media/passBGbottom.40dcf76a.svg";